import { createPaginatedListSlice } from './generators/paginatedList.store';

const slice = createPaginatedListSlice('stations')

export const {
    stationsGetListDataAction,
    stationsSetListDataAction,
    stationsSetPageAction,
    stationsSetSliceAction,
    stationsError
} = slice.actions

export default slice.reducer
